import { createContext } from "react";

export interface ComparisonDialogContextValue {
  showComparision: boolean;
  openComparisonDialog: () => void;
  closeComparisonDialog: () => void;
}

export const ComparisonDialogContext = createContext<ComparisonDialogContextValue | null>(null);
